import { getEnv } from '@ctct/ctct-helpers';

import { BaseApiClient } from '../BaseApiClient';

class AccountSvcApi {
  private baseApiClient: BaseApiClient;

  constructor() {
    const baseUrl = `https://app${getEnv()}constantcontact.com/v1/account`;

    this.baseApiClient = new BaseApiClient(baseUrl);
  }

  public getMfaStatus() {
    return this.baseApiClient.get<unknown>('/user/mfaStatus');
  }

  public getMfaFactors() {
    return this.baseApiClient.get<unknown>('/user/factors');
  }

  public getAccountRoles(uid: string) {
    return this.baseApiClient.get<unknown>(`/customer/users/${uid}/roles`);
  }

  public getCurrentAccountRoles() {
    return this.baseApiClient.get<unknown>(`/customer/users/roles`);
  }

  public getCustomer() {
    return this.baseApiClient.get<unknown>('/customer');
  }

  public getSmsStatusSummary() {
    return this.baseApiClient.get<unknown>('/sms/statusSummary');
  }

  public getCustomerWithPhysicalAddress() {
    return this.baseApiClient.get<unknown>('/customer?extraFields=physicalAddress');
  }

  public listEmailAddresses() {
    return this.baseApiClient.get<unknown>(`/customer/emails`);
  }

  public sendVerificationEmail(emailId: number) {
    return this.baseApiClient.post<unknown, Record<string, never>>(
      `/customer/emails/${emailId}/sendVerificationLetter`,
      {}
    );
  }
}

export const accountSvcApi = new AccountSvcApi();
